import { NavLink } from 'react-router-dom';

const NAV_ITEMS = [
  { to: '/', label: 'Overview', icon: OverviewIcon, end: true },
  { to: '/publishers', label: 'Publishers', icon: PublishersIcon },
  { to: '/demand-partners', label: 'Demand Partners', icon: DemandIcon },
  { to: '/inbound-seats', label: 'Inbound Seats', icon: SeatsIcon },
  { to: '/traffic-controls', label: 'Traffic Controls', icon: QpsIcon },
  { to: '/reporting-feeds', label: 'Reporting Feeds', icon: FeedsIcon },
  { to: '/supply-quality', label: 'Supply Quality', icon: SupplyQualityIcon },
  { to: '/diagnostics', label: 'Diagnostics', icon: DiagnosticsIcon },
  { to: '/auction-log', label: 'Auction Log', icon: AuctionLogIcon },
  { to: '/audit-log', label: 'Audit Log', icon: AuditIcon },
  { to: '/team', label: 'Team', icon: TeamIcon },
];

export default function Sidebar({ operator, onLogout }) {
  return (
    <aside className="sidebar">
      <div className="sidebar__brand">
        <span className="sidebar__logo-mark">B</span>
        <span className="sidebar__wordmark">
          Bid<span className="sidebar__wordmark-accent">Digi</span>
        </span>
      </div>
      <div className="sidebar__section-label">Console</div>
      <nav className="sidebar__nav">
        {NAV_ITEMS.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) => `sidebar__link${isActive ? ' sidebar__link--active' : ''}`}
          >
            <Icon />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
      <div className="sidebar__footer">
        {operator && (
          <div className="sidebar__operator">
            <div className="sidebar__avatar">{initials(operator.name || operator.email)}</div>
            <div className="sidebar__operator-meta">
              <div className="sidebar__operator-name">{operator.name || operator.email}</div>
              <div className="sidebar__operator-email">{operator.email}</div>
            </div>
          </div>
        )}
        <button className="sidebar__logout" onClick={onLogout}>
          Sign out
        </button>
      </div>
    </aside>
  );
}

function initials(text) {
  if (!text) return '?';
  const parts = text.trim().split(/\s+/);
  const first = parts[0]?.[0] || '';
  const last = parts.length > 1 ? parts[parts.length - 1]?.[0] : '';
  return (first + last).toUpperCase() || text[0].toUpperCase();
}

function OverviewIcon() {
  return (
    <svg viewBox="0 0 20 20" width="18" height="18" fill="none">
      <path d="M3 11.5 8 6l4 4 5-5.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3 16h14" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}
function PublishersIcon() {
  return (
    <svg viewBox="0 0 20 20" width="18" height="18" fill="none">
      <rect x="3" y="4" width="14" height="12" rx="2" stroke="currentColor" strokeWidth="1.6" />
      <path d="M6.5 8h7M6.5 11.5h4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}
function DemandIcon() {
  return (
    <svg viewBox="0 0 20 20" width="18" height="18" fill="none">
      <circle cx="6" cy="10" r="3" stroke="currentColor" strokeWidth="1.6" />
      <circle cx="14" cy="6" r="2.4" stroke="currentColor" strokeWidth="1.6" />
      <circle cx="14" cy="14" r="2.4" stroke="currentColor" strokeWidth="1.6" />
      <path d="M8.6 8.8 11.8 6.9M8.6 11.2 11.8 13.1" stroke="currentColor" strokeWidth="1.4" />
    </svg>
  );
}
function FeedsIcon() {
  return (
    <svg viewBox="0 0 20 20" width="18" height="18" fill="none">
      <path d="M4 15.5a1 1 0 1 0 0-.01" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M4 10.5a5 5 0 0 1 5 5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M4 5.5a10 10 0 0 1 10 10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

function QpsIcon() {
  return (
    <svg viewBox="0 0 20 20" width="18" height="18" fill="none">
      <path d="M3 14a7 7 0 1 1 14 0" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M10 14 13.2 8.6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <circle cx="10" cy="14" r="1.3" fill="currentColor" />
    </svg>
  );
}

function SeatsIcon() {
  return (
    <svg viewBox="0 0 20 20" width="18" height="18" fill="none">
      <rect x="3.5" y="7" width="13" height="9" rx="1.6" stroke="currentColor" strokeWidth="1.6" />
      <path d="M6.5 7V5.5A1.5 1.5 0 0 1 8 4h4a1.5 1.5 0 0 1 1.5 1.5V7" stroke="currentColor" strokeWidth="1.6" />
      <circle cx="10" cy="11.3" r="1.4" stroke="currentColor" strokeWidth="1.4" />
    </svg>
  );
}
function DiagnosticsIcon() {
  return (
    <svg viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M2.5 12.5h3l2-6 3 10 2.5-7 1.5 3h3" />
    </svg>
  );
}

function SupplyQualityIcon() {
  return (
    <svg viewBox="0 0 20 20" width="18" height="18" fill="none">
      <path d="M10 3.5 4 6v4.2c0 3.4 2.4 5.7 6 6.8 3.6-1.1 6-3.4 6-6.8V6l-6-2.5Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <path d="M7.4 10 9.2 11.8 12.8 8.2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
function AuctionLogIcon() {
  return (
    <svg viewBox="0 0 20 20" width="18" height="18" fill="none">
      <path d="M3 15.5V13l3-4.5 3 2.5 3-5.5 3 4v6H3Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <path d="M3 15.5h14" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}
function AuditIcon() {
  return (
    <svg viewBox="0 0 20 20" width="18" height="18" fill="none">
      <path d="M5 3.5h7l3 3V16a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4.5A1 1 0 0 1 5 3.5Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <path d="M7 9h6M7 12h6M7 15h3.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  );
}
function TeamIcon() {
  return (
    <svg viewBox="0 0 20 20" width="18" height="18" fill="none">
      <circle cx="7.5" cy="7" r="2.4" stroke="currentColor" strokeWidth="1.6" />
      <circle cx="14" cy="8" r="1.9" stroke="currentColor" strokeWidth="1.6" />
      <path d="M3 16c.4-2.6 2.2-4 4.5-4s4.1 1.4 4.5 4M12.5 16c.3-1.9 1.5-3 3.5-3s2.9.9 3.2 2.4"
        stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
